(() => {
  const library = window.FoxTheme?.Swiper;
  if (!library?.Swiper) return;
  const modules = ['Navigation', 'Pagination', 'Thumbs', 'Autoplay', 'EffectFade', 'Mousewheel', 'Controller', 'A11y']
    .map((name) => library[name]).filter(Boolean);
  window.Swiper = class extends library.Swiper {
    constructor(element, options = {}) {
      super(element, { ...options, modules: [...modules, ...(options.modules || [])] });
    }
  };
})();
